// extracted by mini-css-extract-plugin
export default {"centered":"z-publications_centered__WO78a","title":"z-publications_title__rPRJg"};